module.exports = __webpack_public_path__ + "assets/img/negative-icon.a9ee65e6.svg";